<script setup lang="ts">
/* eslint-disable max-len */
</script>

<template>
  <svg width="26" height="16" viewBox="0 0 26 16" xmlns="http://www.w3.org/2000/svg">
    <g fill-rule="nonzero" fill="none">
      <path fill="#FF5F00" d="M9.457 1.71h7.01v12.579h-7.01z" />
      <path
        d="M9.902 8a7.982 7.982 0 0 1 3.06-6.29 8.02 8.02 0 0 0-10.836.862 7.991 7.991 0 0 0 0 10.856 8.02 8.02 0 0 0 10.836.862A7.982 7.982 0 0 1 9.902 8z"
        fill="#EB001B"
      />
      <path
        d="M25.924 8a7.999 7.999 0 0 1-4.51 7.195 8.02 8.02 0 0 1-8.452-.905 7.997 7.997 0 0 0 0-12.58 8.02 8.02 0 0 1 8.452-.905A7.999 7.999 0 0 1 25.924 8zM25.16 12.957V12.7h.103v-.053H25v.053h.104v.257h.056zm.514 0v-.31h-.082l-.093.213-.093-.213h-.082v.31h.058v-.234l.087.202h.06l.087-.203v.235h.058z"
        fill="#F79E1B"
      />
    </g>
  </svg>
</template>
